import { type FC, memo, type ReactNode, useCallback, useState } from "react";
import { QuoteSplitDialog } from "./QuoteSplitDialog";

interface RenderProps {
  openPopup: () => void;
  closePopup: () => void;
}

interface QuoteSplitPopupContextProps {
  children: (props: RenderProps) => ReactNode;
}

const QuoteSplitPopupContext: FC<QuoteSplitPopupContextProps> = ({ children }) => {
  const [open, setOpen] = useState(false);

  const openPopup = useCallback(() => {
    setOpen(true);
  }, []);

  const closePopup = useCallback(() => setOpen(false), []);

  const props = { openPopup, closePopup };

  return (
    <>
      {children(props)}
      {open && <QuoteSplitDialog onClose={closePopup} />}
    </>
  );
};
export default memo(QuoteSplitPopupContext);
